export default __webpack_public_path__ + "static/instance02-292ec5fc80df9e2f5bf734d91662ba76.png";